import React, { useRef, useState } from "react";
import Modal from 'react-modal';
import CloseIcon from '@mui/icons-material/Close';
import { useGlobalContext } from "../../../Context/GlobalContext";
import Cookies from "js-cookie";

const VerifyPan = () => {

    const { baseUrl, selectedStaff, openToast } = useGlobalContext();
    const [isLoading, setIsLoading] = useState(false);


    let subtitle;
    const [pan, setPan] = useState({
        number: selectedStaff?.staffDetails?.staff_bg_verification?.pan_number,
        status: selectedStaff?.staffDetails?.staff_bg_verification?.pan_verification_status,
        verificationFile: selectedStaff?.staffDetails?.staff_bg_verification?.pan_file
    });

        const [pan1, setPan1] = useState({ verificationFile: selectedStaff?.staffDetails?.staff_bg_verification?.pan_file || null });
    




    async function submitPan() {
        setIsLoading(true);
        if (!pan?.number || !pan?.verificationFile) {
            openToast("Provide either pan number or upload file", "warning");
            return;
        }
        const newFormData = new FormData();
        newFormData.append("pan_number", pan?.number);
        newFormData.append("verificationFile", pan?.verificationFile);

        try {
            const response = await fetch(baseUrl + "bg-verification/" + selectedStaff.staffDetails.id + "/verify/pan", {
                method: "PUT",
                headers: {
                    // "Content-Type": "multipart/form-data",
                    Authorization: `Bearer ${Cookies.get("token")}`
                },
                body: newFormData
            });

            console.log(response);

            if (response.status === 201) {
                const result = await response.json();
                console.log(result);
                setPan({ ...pan, number: result?.data?.pan_number, status: result?.data?.pan_verification_status, verificationFile: result?.data?.pan_file });
                openToast("Pan successfully updated or created", "success");
                closeModal2();
            } else {
                openToast("An error occurred while adding or updating Pan", "error");
            }
        } catch (error) {
            console.error("Error submitting Pan:", error);
            openToast("An error occurred while adding or updating Pan", "error");
        }
        finally {
            setIsLoading(false);
        }
    }


    const [modalIsOpen2, setIsOpen2] = React.useState(false);
    function openModal2() {
        setIsOpen2(true);
    }
    function afterOpenModal2() {
        // references are now sync'd and can be accessed.
        subtitle.style.color = '#000';

    }

    function closeModal2() {
        setIsOpen2(false);
    }

    const fileInputRef = useRef(null);

    const handleUploadClick = () => {
        fileInputRef.current.click();
    };

    // Function to handle file selection
    const handleFileChange = (event) => {
        const file = event.target.files[0];
        setPan({ ...pan, verificationFile: file });
        if (file) {
            const fileURL = URL.createObjectURL(file); // Create a blob URL for the file
            setPan1({ ...pan1, verificationFile: fileURL }); // Update state with the file URL
        }
    };


    return (
        <div className='relative flex flex-col xl:pt-[30px] w-full'>
            <div className='top-0 flex justify-between items-center bg-white pr-0 xl:pr-[0px] pb-[10px] pl-[0] w-[100%]'>
                <h3 className='font-medium'>PAN Verification</h3>
                <button className={'second-btn ' + (isLoading && "animate-pulse opacity-50 cursor-not-allowed")} disabled={isLoading} onClick={submitPan}>
                    Update Pan
                </button>
            </div>

            <div className='flex justify-between items-center border-1 bg-[#fff] shadow-cs mb-3 p-4 border rounded-lg' >
                <h4 className='font-light'>PAN</h4>
                <p className='font-light'>{pan?.number}</p>
                <button className='second-btn' onClick={openModal2}  >
                    Add
                </button>

            </div>


            <div className='flex justify-between items-center border-1 bg-[#fff] shadow-cs mb-3 p-4 border rounded-lg' >
                <h4 className='font-light'>Verification Status
                </h4>
                <p className='font-light'>{pan?.status}
                </p>

            </div>


            <div className='flex justify-between items-center border-1 bg-[#fff] shadow-cs mb-3 p-4 border rounded-lg' >
                <h4 className='font-light'>Proofs</h4>
                <input
                    type="file"
                    ref={fileInputRef}
                    onChange={handleFileChange}
                    style={{ display: "none" }}
                    required
                />
               <div className="flex justify-center items-center bg-gray-100 border rounded-md w-[100px] h-[50px] image-container">
                    {pan1?.verificationFile ? (
                        typeof pan1.verificationFile === "string" ? (
                            <img
                                src={pan1.verificationFile}
                                alt="Selected File"
                                className="rounded-md max-w-full max-h-full"
                            />
                        ) : (
                            <span className="text-gray-500 text-sm">Invalid file</span>
                        )
                    ) : (
                        <span className="text-gray-500 text-sm">No file</span>
                    )}
                </div>

                <button className='second-btn' onClick={handleUploadClick}>
                    Upload
                </button>

            </div>


            <Modal
                isOpen={modalIsOpen2}
                onAfterOpen={afterOpenModal2}
                onRequestClose={closeModal2}
                contentLabel="Example Modal"
                className="top-[50%] bottom-auto left-[50%] absolute bg-[#fff] shadow-cs p-0 rounded-[10px] w-[96%] xl:w-[40%] translate-x-[-50%] translate-y-[-50%]"

            >
                <h2 ref={(_subtitle) => (subtitle = _subtitle)} className='p-3 border-b-1 text-[13px] xl:text-[15px]'>Add PAN</h2>
                <button onClick={closeModal2} className='top-[3px] right-[5px] absolute bg-[#27004a] rounded-full font-semibold'><CloseIcon className='text-white' /></button>
                <div className=''>
                    <div className='p-[10px] border border-t field-modal modal-field'>
                        <label className='font-medium text-[13px] xl:text-[14px]' >PAN
                        </label><br />
                        <input type='text' placeholder="Enter PAN" className='border-1 newsetup3 mt-1 mb-[10px] p-[5px] border rounded-md w-[100%] placeholder:font-font-normal text-[#000] text-[14px] focus:outline-none' value={pan?.number} onChange={(e) => setPan({ ...pan, number: e.target.value })} required /><br />
                    </div>
                    <div className='flex justify-end gap-[10px] pt-3 pr-[10px] pb-3 border-t'>
                        <button className='first-btn' onClick={closeModal2}>Cancel</button>
                        <button className='second-btn' onClick={closeModal2}>Save </button>
                    </div>
                </div>
            </Modal>

        </div>
    )
}

export default VerifyPan